import React, { useState } from "react";
import { Button, Grid } from "@material-ui/core";
import CommentIcon from "@material-ui/icons/Comment";
import { PropertiesModal } from "../properties-modal/properties-modal";

interface Props {
	data: any;
	searchAssetAttachments: Function;
}

export const AttachmentsCommentsColumn = ({
	data,
	searchAssetAttachments,
}: Props) => {
	const [openPropertiesModal, setOpenPropertiesModal] = useState(false);

	if (data) {
		return (
			<>
				<Grid container item style={{ justifyContent: "center" }}>
					{data?.Comments && (
						<Grid item md={12} xs={12}>
							<Button
								onClick={() => setOpenPropertiesModal(true)}
								fullWidth
								color="primary"
								style={{
									textDecoration: "none",
									fontWeight: 500,
									fontSize: "12px",
									borderRadius: "3px",
									marginRight: 8,
								}}
								title={`${(data?.Comments).substr(0, 50)}...`}
							>
								<CommentIcon />
							</Button>
						</Grid>
					)}
				</Grid>
				<PropertiesModal
					searchAssetAttachments={searchAssetAttachments}
					show={openPropertiesModal}
					rowSelected={data as any}
					onHide={() => setOpenPropertiesModal(false)}
				/>
			</>
		);
	} else return <></>;
};
